<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <modelo-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ModeloShowData from "./ModeloShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ModeloShow",
        components: {CrudShow, ModeloShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'modelo.showing',
            }
        },
    }
</script>

